import styles from './WorkshopList.module.scss';
import stylesForm from "../../styles/pages/form.module.scss";
import Swal from "sweetalert2";
import SwiperCore, { Autoplay, FreeMode, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { parse, format, addMinutes, getMonth, getDate, addDays } from 'date-fns'
import { it, enGB, fr, zhCN, ko, ru, ja, enUS } from 'date-fns/locale'
import { useContext, useEffect, useState, useRef } from 'react';
import { ApplicationContext } from "../../context/ApplicationContext";
import { useForm } from "react-hook-form";
import CloseIcon from "../../public/assets/icons/closeIcon.svg";
import ReactDOMServer from "react-dom/server";
import Input from '../Input/Input';
import { getCookie, setCookies, checkCookies, removeCookies } from "cookies-next";
import { useRouter } from 'next/router';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import strEn from '../../public/langs/strings_en.js'
import strIt from '../../public/langs/strings_it.js';
import strFr from '../../public/langs/strings_fr.js';
import strRu from '../../public/langs/strings_ru.js';
import strCh from '../../public/langs/strings_ch.js';
import strJa from '../../public/langs/strings_ja.js';
import strKo from '../../public/langs/strings_ko.js';

SwiperCore.use([Autoplay, Pagination, Navigation, FreeMode]);
SwiperCore.use([Autoplay, Pagination, Navigation, FreeMode]);

function formatDate(start_date, end_date, start_time, end_time, days, locale) {
  let finalStr = '';
  if(start_date == end_date) {
    let d = parse(start_date+' '+start_time, "yyyy-MM-dd kk:mm:ss", new Date(), {locale: locale});
    return format(d, "dd MMMM", {locale: locale});
  }
  else {
    let daysarr = days.split(',');
    let month = '';
    let retStr = '';
    for(let i = 0; i < daysarr.length; i++) {
      let d = parse(daysarr[i]+' '+start_time, "yyyy-MM-dd kk:mm:ss", new Date(), {locale: locale});
      let curMonth = format(d, "MMMM", {locale: locale});

      if(retStr == '')
        retStr += getDate(d);
      else if(month != '' && curMonth != month)
        retStr += ' '+month+', '+getDate(d);
      else
        retStr += '-'+getDate(d);

      if(i == daysarr.length - 1)
        retStr += ' '+month;

      month = curMonth;
    }
    return retStr;
  }
}

function formatTime(start_time, end_time, locale) {
  let st = parse(start_time.substr(0, 5), "kk:mm", new Date(), {locale: locale});
  let et = parse(end_time.substr(0, 5), "kk:mm", new Date(), {locale: locale});
  return format(st, "p", {locale: locale})+' - ' + format(et, "p", {locale: locale});
  return st+'-'+et;
  //return start_time.substr(0, 5)+'-'+end_time.substr(0, 5);
}
function formatStartTime(start_time, locale) {
  let st = parse(start_time.substr(0, 5), "kk:mm", new Date(), {locale: locale});
  return format(st, "p", {locale: locale});
}

export default function WorkshopList({workshops, form_login, form_loyalty, properties}) {
  //console.log(workshops, form_login, form_loyalty);
  const { setShowLoader } = useContext(ApplicationContext);
  const [loadingCount, setLoadingCount] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [profile, setProfile] = useState(null);
  const [calendar, setCalendar] = useState(null);
  const router = useRouter();
  const listRef = useRef(null);
  const [selectedWorkshop, setSelectedWorkshop] = useState(-1);
//console.log('workshops', workshops);

  let lang = 'en';
  try {
    lang = window ? window?.location.pathname.split('/')[1] : '';
  } catch(e) {}
  let userLang = 'english';
  let langStr = null;
  let locale = enGB;
  switch(lang) {
    case 'en':
      langStr = strEn;
      locale = enUS;
      break;
    case 'it':
      langStr = strIt;
      locale = it;
      break;
    case 'fr':
      langStr = strFr;
      locale = fr;
      break;
    case 'zh':
      langStr = strCh;
      locale = zhCN;
      break;
    case 'jp':
      langStr = strJa;
      locale = ja;
      break;
    case 'ru':
      langStr = strRu;
      locale = ru;
      break;
    case 'kr':
      langStr = strKo;
      locale = ko;
      break;
  }

  useEffect(() => {
    if(getCookie("myarea")) {
      setLoadingCount( c => c + 1);
      fetch(
        `${process.env.NEXT_PUBLIC_FE_COMMON}/customer?token=` +
        JSON.parse(getCookie("myarea")).access_token
      )
      .then(resProfile => {
        return resProfile.json();
      })
      .then(prof => {
        console.log('PROFILE', prof);
        setIsLoggedIn(true);
        setProfile(prof?.response);
      })
      .finally(() => {
        setLoadingCount( c => c - 1 );
      })
    }

    const sp = new URLSearchParams(location.search);
    const wid = sp.get('wid');
    if(wid) {
      const baseUrl = process.env.NEXT_PUBLIC_DATA_BASEURL.replace("api", "themall_workshop");
      fetch(baseUrl + '/service/'+wid+'/calendar_extra')
      .then(resWorkshop => {
        return resWorkshop.json();
      })
      .then(wCalendar => {
        //console.log('CALENDAR', wCalendar);
        setCalendar(wCalendar);
      })
      .finally(() => {
        setLoadingCount( c => c - 1 );
      });

      setSelectedWorkshop(wid);
      window.scrollTo({top: listRef.current.offsetTop - 50})
    }
  }, []);


  function loadWorkshopDetail(wid) {
    setSelectedWorkshop(wid);
    if(isLoggedIn&& wid && wid > 0) {
      setShowLoader(true);
      const baseUrl = process.env.NEXT_PUBLIC_DATA_BASEURL.replace("api", "themall_workshop");
      fetch(baseUrl + '/service/'+wid+'/calendar_extra')
      .then(resWorkshop => {
        return resWorkshop.json();
      })
      .then(wCalendar => {
        //console.log('CALENDAR', wCalendar);
        setCalendar(wCalendar);
      })
      .finally(() => {
        setShowLoader(false);
      });
    }
  }

  useEffect(() => {
    if(loadingCount > 0)
      setShowLoader(true);
    else
      setShowLoader(false);
  } ,[loadingCount]);
 

  const onSubmit = async (event) => {
      setShowLoader(true);
      const res = await fetch(
          `${process.env.NEXT_PUBLIC_FE_LOGIN}`,
          {
              method: "POST",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                  username: event.email,
                  password: event.password,
              }),
          }
      );

      const resjs = await res.json();

      if (resjs?.result == false) {
          setShowLoader(false);
          Swal.fire({
              title: properties[resjs.message],
              showCloseButton: true,
              showCancelButton: false,
              showConfirmButton: false,
              closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
          });
      } else {
          if (resjs?.response && !resjs.response.error) {
              const loyalty = await fetch(
                  `${process.env.NEXT_PUBLIC_FE_EMAIL}` +
                  event.email
              );

              const loyaltyjs = await loyalty.json();
              if (checkCookies("myarea")) {
                  removeCookies("myarea");
              }
              if (loyaltyjs?.response?.programKeys) {
                  setCookies(
                      "myarea",
                      {
                          access_token: resjs.response.access_token,
                          refresh_token: resjs.response.refresh_token,
                          loyalty: true,
                          first_name: resjs.response.first_name
                      },
                      {
                          maxAge: 3600,
                      }
                  );
                  //setShowLoader(false);
                  const sp = new URLSearchParams(location.search);
                  const wid = sp.get('wid');
                  if(wid)
                    router.reload();
                  else
                    location.href = location.href + '?wid=' + selectedWorkshop;
                  //router.push(location.pathname+'?wid='+selectedWorkshop);
                  //router.reload()
              } else {
                  setCookies(
                      "myarea",
                      {
                          access_token: resjs.response.access_token,
                          refresh_token: resjs.response.refresh_token,
                          loyalty: false,
                          first_name: resjs.response.first_name
                      },
                      {
                          maxAge: 3600,
                      }
                  );
                  //setShowLoader(false);
                  location.href = location.href + '?wid=' + selectedWorkshop;
                  //router.push(location.pathname+'?wid='+selectedWorkshop);
                  //router.reload()
              }
          } else {
              // setShowLoader(false);
              Swal.fire({
                  title: resjs.response.error_description,
                  // text: 'Booking an experience is not available at the moment.',
                  showCloseButton: true,
                  showCancelButton: false,
                  showConfirmButton: false,
                  closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
              });
          }
      }
  };

  const onRegister = async (data) => {
    //console.log('register', data);

    const okMessages = {
      'it': 'Registrazione confermata! A breve riceverai una e-mail di riepilogo della tua prenotazione.',
      'en': 'Registration confirmed! You will shortly receive a booking summary e-mail.',
      'fr': 'Inscription confirmée ! Vous allez bientôt recevoir un e-mail récapitulant votre réservation.',
      'zh': '注册已确认！您将很快收到一封预订确认邮件。',
      'kr': '등록이 확인되었습니다! 곧 예약 확인 이메일을 받게 됩니다.',
      'jp': '登録が確認されました！予約の概要を記載した電子メールがまもなく送信されます。',
      'ru': 'Регистрация подтверждена! В ближайшее время вы получите электронное письмо с информацией о Вашей записи.'
    };

    const koMessages = {
      'it': 'Registrazione fallita, riprova più tardi.',
      'en': 'Registration failed, please retry later.',
      'fr': 'Échec de l\'enregistrement, veuillez réessayer plus tard.',
      'zh': '注册失败，请稍后再试。',
      'kr': '등록에 실패했습니다. 나중에 다시 시도해 주세요.',
      'jp': '登録に失敗しました。後でもう一度お試しください。',
      'ru': 'Не удалось зарегистрироваться, попробуйте позже.'
    }

    const baseUrl = process.env.NEXT_PUBLIC_DATA_BASEURL.replace("api", "themall_workshop");

    let startTime = parse(data['date']+ ' '+data['start_time'], "yyyy-MM-dd kk:mm:ss", new Date(), {locale: locale}); 
    let endTime = addMinutes(startTime, data['slot_len']);

    data['end_time'] = format(endTime, "kk:mm:ss");
    delete data['slot_len'];
    data['customer_timezone'] = "Europe/Rome";

    setShowLoader(true);
    const res = await fetch(baseUrl + '/bookings', {
      method: 'POST',
      headers: {
        Authorization: JSON.parse(getCookie("myarea")).access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data)
    });
    const resjs = await res.json();
    //console.log('BOOKING RESULT', resjs);
    if(resjs.result == 'CONFIRMED') {
      Swal.fire({
        title: okMessages[lang],
        // text: 'Booking an experience is not available at the moment.',
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
      }).then( () => {
        setSelectedWorkshop(-1);
      });
    }
    else if(resjs.result == 'SLOT_UNAVAILABLE') {
      Swal.fire({
        title: langStr['slot unavailable'],
       // text: 'Non è disponibile il numero di posti richiesto',
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
      });
    }
    else {
      Swal.fire({
        title: koMessages[lang],
        //text: 'Riprova più tardi',
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
      });
    }
    setShowLoader(false);
  }

  
  return <div className={styles.workshopList} ref={listRef}>
    {selectedWorkshop < 0 && <div className='centeredSection'>
      <div className={styles.sectionTitle}>{langStr?.['workshop list']}</div>
      <div className={styles.swiperContainer}>
        <Swiper
                    onInit={swiper => {swiper.slideTo(0, 0);}}
                    pagination={{clickable: true, el: '.swiperCalendarPagination'}}
                    slidesPerView={"auto"}
                    modules={[Pagination]}
                    spaceBetween={31}
                    
                    speed={2000}
                    autoplay={false}
                  >
          {workshops?.services?.map( (w, i) => <SwiperSlide key={i} className={styles.workshopItem}>
            <div className={styles.title}>{w.title}</div>
            <div className={styles.subtitle}>{w.subtitle}</div>

            <div className={styles.date}>{formatDate(w.start_date, w.end_date, w.start_time, '', w.days, locale)}</div>
            <div className={styles.time}><span className="material-symbols-outlined">
schedule
</span> {formatTime(w.start_time, w.end_time, locale)}</div>
            {w?.location != '' && w?.location != null && <div className={styles.where}><span className="material-symbols-outlined">
location_on
</span> {w.location}</div>}

            <div className={styles.description}>{w.description}</div>
            <div className={styles.buttons}>
              <button onClick={() => {loadWorkshopDetail(w.id) }}>{langStr['signup']}</button>
            </div>
          </SwiperSlide>)}
        </Swiper>
        <div className="swiperCalendarPagination"></div>
      </div>
    </div>}
    {isLoggedIn && selectedWorkshop > 0 && <div className='centeredSection'>
      <WorkshopForm onRegister={onRegister} close={() => setSelectedWorkshop(-1)} workshop={workshops?.services?.find(s => s.id == selectedWorkshop)} calendar={calendar?.calendar} profile={profile} loginData={form_login} properties={properties} />
    </div>}
    {!isLoggedIn && selectedWorkshop > 0 && <div className="centeredSection">
      <LoginForm onSubmit={onSubmit} loginData={form_login} close={() => setSelectedWorkshop(-1)} selectedWorkshop={selectedWorkshop} />
      </div>}
  </div>;
}

export function WorkshopForm({workshop, calendar, profile, onRegister, close, editing}) {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();


  const disclaimerMessages = {
    'it': '<ul><li>Presentarsi circa 15 minuti prima dell\'inizio del workshop.</li><li>La partecipazione al workshop è garantita fino a massimo 10 minuti dall\'orario di inizio del workshop. In caso di ritardo superiore ai 10 minuti lo slot verrà reso disponibile per gli altri ospiti.</li><li>L\'iscrizione è nominale, non cedibile e consente la partecipazione a un solo slot orario per workshop.</li></ul>',
    'en': '<ul><li>Please arrive approximately 15 minutes before the workshop start time.</li><li>Participation in the workshop is guaranteed up to 10 minutes after the workshop start time.  In the event of delays over 10 minutes, the slot will be made available to other guests.</li><li>The registration has no face value, is non-transferable and is valid for one workshop time slot only.</li></ul>',
    'fr': '<ul><li>Se présenter environ 15 minutes avant le début de l\'atelier.</li><li>La participation à l\'atelier est garantie jusqu\'à 10 minutes maximum par rapport à l\'horaire de début de l\'atelier. En cas de retard supérieur à 10 minutes, le créneau horaire sera proposé aux autres invités.</li><li>L\'inscription est nominative, non transférable et ne permet de participer qu\'à un seul créneau horaire par atelier. </li></ul>',
    'zh': '<ul><li>请在工作坊开始前大约15分钟到达。</li><li>在工作坊开始后的10分钟内，您的参与名额将得到保留。若延迟超过10分钟，名额将开放给其他宾客。</li><li>该注册不具有现金价值，不可转让，仅适用于一个工作坊时段。</li></ul>',
    'kr': '<ul><li>워크숍 시작 시간 약 15분 전에 도착해 주세요.</li><li>워크숍 시작 후 10분 이내에는 참가가 보장됩니다. 10분 이상 지연될 경우, 해당 자리는 다른 고객에게 제공될 수 있습니다.</li><li>등록은 금전적 가치가 없으며, 양도할 수 없고, 하나의 워크숍 시간대에만 유효합니다.</li></ul>',
    'jp': '<ul><li>集合時間はワークショップ開始の約15分前です。</li><li>ワークショップへの遅刻参加は、ワークショップ開始時刻から最大10分後までに限り承ります。10分以上の遅刻があった場合、出席枠が他のゲストに譲られます。</li><li>登録は本人限定で譲渡できず、ワークショップごとに1つのタイムスロットへの参加が許可されます。 </li></ul>',
    'ru': '<ul><li>Рекомендуется приходить примерно за 15 минут до начала мероприятия.</li><li>Участие в мероприятии гарантировано в течение не более 10 минут после его начала. В случае опоздания более чем на 10 минут запись на соответствующее время будет предложена другим гостям.</li><li>Запись на мероприятие является именной, не подлежит передаче другому лицу и действует только на выбранное время участия. </li></ul>',
  };

  const saveString = {
    'it': 'Salva',
    'en': 'Save',
    'fr': 'Enregistre',
    'zh': '保存',
    'kr': '저장',
    'jp': '保存',
    'ru': 'Сохрани'
  };

  const timeVal = watch('start_time');
  const dateVal = watch('date');
  const dateInd = calendar?.findIndex(d => (d.date == dateVal || d.date == workshop.date) );


  const timeOptions = [];
  const numOptions = [];

  const lang = window.location.pathname.split('/')[1];
  let userLang = 'english';
  let langStr = null;
  let locale = enGB;
  switch(lang) {
    case 'en':
      userLang = 'english';
      langStr = strEn;
      locale = enUS;
      break;
    case 'it':
      userLang = 'italian';
      langStr = strIt;
      locale = it;
      break;
    case 'fr':
      userLang = 'french';
      langStr = strFr;
      locale = fr;
      break;
    case 'zh':
      userLang = 'chinese';
      langStr = strCh;
      locale = zhCN;
      break;
    case 'jp':
      userLang = 'japanese';
      langStr = strJa;
      locale = ja;
      break;
    case 'ru':
      userLang = 'russian';
      langStr = strRu;
      locale = ru;
      break;
    case 'kr':
      userLang = 'korean';
      langStr = strKo;
      locale = ko;
      break;
  }

  //console.log('calendar', workshop, calendar, profile);
  function getAvailableSlots() {
    let options = [];
    let slotBooked = {};

    if(dateInd == null || dateInd == -1 || workshop == null) return options;

    for(let i = 0; i < calendar?.[dateInd].bookings?.length; i++) {
      if(slotBooked.hasOwnProperty( calendar[dateInd].bookings[i].start_time ))
        slotBooked[calendar[dateInd].bookings[i].start_time] += parseInt(calendar[dateInd].bookings[i].num_people);
      else
        slotBooked[calendar[dateInd].bookings[i].start_time] = parseInt(calendar[dateInd].bookings[i].num_people);
    }
    let breaks = calendar?.[dateInd].breaks ? calendar?.[dateInd].breaks?.map(b => { 
      return {
        start: parse(calendar?.[dateInd]?.date+ ' '+b.start+':00', "yyyy-MM-dd kk:mm:ss", new Date(), {locale: locale}),
        end: parse(calendar?.[dateInd]?.date+ ' '+b.end+':00', "yyyy-MM-dd kk:mm:ss", new Date(), {locale: locale})
      } 
    }) : [];
    
    let startTime = parse(calendar?.[dateInd]?.date+ ' '+calendar?.[dateInd]?.start_time, "yyyy-MM-dd kk:mm:ss", new Date(), {locale: locale});
    let endTime = parse(calendar?.[dateInd]?.date+ ' '+calendar?.[dateInd]?.end_time, "yyyy-MM-dd kk:mm:ss", new Date(), {locale: locale});

    let breakInd = 0;
    while(endTime > startTime) {
      while(breaks.length > breakInd && startTime > breaks[breakInd].end) {
        console.log(startTime, '> ', breaks[breakInd].end)
        breakInd++;
      }

      if(breaks.length > breakInd && startTime >= breaks[breakInd].start && startTime < breaks[breakInd].end) {
        // skip
      }
      else {
        let startString = format(startTime, "kk:mm");
        let num_avail = workshop.slot_size - (slotBooked.hasOwnProperty(startString+':00') ? slotBooked[startString+':00'] : 0);
        if(num_avail < 0) num_avail = 0;
        //console.log('MATH: '+workshop.slot_size+' - '+(slotBooked.hasOwnProperty(startString+':00') ? slotBooked[startString+':00'] : 0))

        //if(num_avail > 0)
        let startLabel = format(startTime, "p", {locale: locale});
        options.push({value: startString+':00', label: startLabel, avail: num_avail});
      }
      startTime = addMinutes(startTime, workshop.slot_len);
    }

    return options;
  }
  let availSlots = getAvailableSlots();

  function getMaxPeople() {
    if(workshop == null) return 1;
    if(dateInd == null || dateInd == -1) return 1;
    if(timeVal == null || timeVal == -1) return workshop?.slot_size ?? 1;
    let avail = availSlots?.find(s => s.value == timeVal)?.avail;
    if(avail == null || avail == -1) return 1;
    return workshop?.single_booking <= avail ? workshop?.single_booking : avail;
  }

  //console.log('MAX PEOPLE', getMaxPeople());
  return <div className={styles.workshopSignup + (editing ? ' ' + styles.dark :  '')}>
    <div className={styles.title}>{workshop.service_title ? workshop.service_title : workshop.title}</div>
    {profile && workshop && calendar && <form onSubmit={handleSubmit(onRegister)}>
      <div>
        <CloseIcon className={styles.closeWorkshop} onClick={close} />
        <div className={styles.personForm}>
          <div className={styles.formSectionTitle}>{langStr['your data']}</div>
          <input type="hidden" value={userLang} {...register('preferred_language')} />
          <input type="hidden" value={profile?.public_id} {...register('tmqAccount')} />
          <input type="hidden" value={editing?.service_id ? editing?.service_id : workshop.id} {...register('service_id')} />
          {editing?.id ? <input type="hidden" value={editing?.id} {...register('booking_id')} /> : ''}
          <input type="hidden" value={"TMF"} {...register('mall')} />
          <input type="hidden" value={profile?.title} {...register('customer_title')} />
          <input type="hidden" value={workshop.slot_len} {...register('slot_len')} />
          <div className={styles.formField}>
            <Input key={"first_name"}
              placeholder={langStr['first name']}
              value={editing?.first_name ? editing.first_name : profile?.first_name}
              id={"first_name"}
              name={"first_name"}
              type={"text"}
              disabled={false}
              errorCheck={errors['first_name']}
              error={"missing field"}
              inputProps={{
                ...register('first_name', {
                  required: true
                })
              }} />
          </div>
          <div className={styles.formField}>
            <Input key={"last_name"}
              placeholder={langStr['last name']}
              value={editing?.last_name ? editing.last_name : profile?.last_name}
              id={"last_name"}
              name={"last_name"}
              type={"text"}
              disabled={false}
              errorCheck={errors['last_name']}
              error={"missing field"}
              inputProps={{
                ...register('last_name', {
                  required: true
                })
              }} />
          </div>
          <div className={styles.formField}>
            <Input key={"email"}
              placeholder={langStr['email']}
              value={editing?.email ? editing.email : profile?.email}
              id={"email"}
              name={"email"}
              type={"email"}
              disabled={false}
              errorCheck={errors['email']}
              error={"missing field"}
              inputProps={{
                ...register('email', {
                  required: true,
                  pattern: /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*(\.[a-zA-Z]{2,})$/,
                })
              }} />
          </div>
          <div className={styles.formField}>
            <Input key={"phone_num"}
              placeholder={langStr['phone']}
              value={profile?.phone ? (profile?.phone?.country_code + ' ' + profile?.phone?.number) : (profile?.phone_num ? profile?.phone_num : '' )}
              id={"phone_num"}
              name={"phone_num"}
              type={"text"}
              disabled={false}
              errorCheck={errors['phone_num']}
              error={"missing field"}
              inputProps={{
                ...register('phone_num', {
                  required: true
                })
              }} />
          </div>
        </div>

        <div className={styles.dateForm}>
          <div className={styles.formSectionTitle}>{langStr['date and time']}</div>
          <div className={styles.formField}>
            <label>{langStr['day']}:</label> 
            <select {...register('date')} defaultValue={workshop?.date}>
              <option value="">{langStr['select a date']}</option>
              {calendar.filter( (d) => (parse(d.date+" 12:01", "yyyy-MM-dd HH:mm", new Date(), {locale: it}) > new Date())  ).map( (d, i) => <option key={i} value={d.date}>{format(parse(d.date, "yyyy-MM-dd", new Date(), {locale: it}), "P", {locale: locale})}</option> )}
            </select><span></span>
          </div>
          <div className={styles.formField}>
            <label>{langStr['time']}</label>
            <select {...register('start_time', {required: true})} defaultValue={editing?.start_time ? editing?.start_time : ''}>
              <option value="">{langStr['select hour']}</option>
              {workshop ? availSlots.map( (slot, i) => <option disabled={slot.avail == 0} key={i} value={slot.value}>{slot.label}</option> ) : ''}
            </select><span></span>
            <div className={styles.error}>{errors['start_time'] && <><FontAwesomeIcon icon={faExclamationTriangle} /> {langStr['select hour']}</>}</div>
          </div>
          <div className={styles.formField}>
            <label>{langStr['num people']}:</label> <select {...register('num_people', {required: true})} defaultValue={workshop?.num_people}>
              <option value="1">1</option>
              {Array.from({length: getMaxPeople() - 1}, (v, ind) => <option key={ind}>{ind + 2}</option> ) }
            </select><span></span>
            {errors['num_people'] && <div className={styles.error}>{langStr['err num people']}</div>}
          </div>
          {false && <div className={styles.formField}>
            <label>{langStr['location']}:</label> <div className={styles.fixedValue}>{workshop.location}</div>
          </div>}
        </div>
      </div>

      <div className={styles.disclaimer} dangerouslySetInnerHTML={{__html: disclaimerMessages[lang]}}></div>

      <div className={styles.buttons}>
        <div className={styles.sendRegister}>
          <button type="submit" className={stylesForm.button}>
            {editing ? saveString[lang] : langStr['signup']}
          </button>
        </div>
      </div>

    </form>}
  </div>
}

function LoginForm({onSubmit, loginData, close, selectedWorkshop}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  let registerLink = loginData.links[0]?.url;
  if(loginData.signup_id != null && loginData.signup_id != '')
    registerLink = registerLink + '?s=' + loginData.signup_id + '&redir=' + location.href+'%3Fwid=' + selectedWorkshop;
  else
    registerLink = registerLink + '?redir=' + location.href+'%3Fwid=' + selectedWorkshop;

  return (<div className={styles.loginForm}>
    <CloseIcon className={styles.closeWorkshop} onClick={close} />
    <form onSubmit={handleSubmit(onSubmit)}>
      <Input key={"email"}
              id={'email'}
              name={'email'}
              placeholder={"E-mail"}
              type={'email'}
              errorCheck={errors['email']}
              error={'missing field'}
              inputProps={{
                    ...register(`email`, {
                        required: true,
                        pattern: /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*(\.[a-zA-Z]{2,})$/,
                    }),
                }} />
      <Input key={"password"}
              id={'password'}
              name={'password'}
              placeholder={"password"}
              type={'password'}
              errorCheck={errors['password']}
              error={'missing field'}
              inputProps={{
                    ...register(`password`, {
                        required: true,
                    }),
                }} />
      <div className={styles.forgotPsw}>
        <a
            href={loginData.links[1]?.url}
            target={loginData.links[1]?.target}
        >
            {loginData.links[1]?.title}
        </a>
      </div>
      <div className={styles.sendLogin}>
        <button className={stylesForm.button}>
          {loginData.button_title}
        </button>
      </div>
      
    </form>
    <div className={styles.register}>
      <div className={styles.loginText}> OR </div>
      <a
          href={registerLink}
          className="transparent"
      >
          <button className={stylesForm.button}>
              {loginData.links[0]?.title}
          </button>
      </a>
    </div>
  </div>);
}